function ArrowRightAlt({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="48px"
      viewBox="0 -960 960 960"
      width="48px"
      stroke="currentColor"
      fill="currentColor"
      className={className}
    >
      <path d="m560-242-43-42 168-168H160v-60h525L516-681l43-42 241 241-240 240Z" />
    </svg>
  );
}

export default ArrowRightAlt;
